// import { currencyTypeOptions } from "../SearchResults/SearchFilters/filterOptions"
import { map } from "lodash"
import currencyRate from "../../../public/currency.json"
import { useGlobalStore } from "../../stores/globalStore"
import { formatNumber } from "@lib/utils"

export function calcPrice(price, curr, defaultcurr) {
  if (parseInt(price, 10) <= 0) {
    return 0
  }
  return (
    currencyRate[curr] *
    ((currencyRate.GBP / currencyRate[defaultcurr]) *
      parseInt(String(price)?.replaceAll(/,/g, ""), 10))
  )
}

export const SizeConvert = (sizeVal, strr) => {
  let str = strr ? strr : "";
  const { sizeType } = useGlobalStore();
  if (sizeType === 'ftToM') {
    const sqMeters = Math.round(sizeVal * 0.092903); // Round to the nearest integer
    return formatNumber(sqMeters) + str + " sq m";
  } else {
    const sqFeet = sizeVal;
    return formatNumber(sqFeet) + str + " sq ft";
  }
};

export const SizeConvertNO = (sizeVal, strr) => {
  let str = strr ? strr : ""
  const { sizeType } = useGlobalStore()
  if (sizeType === 'ftToM') {
      const sqMeters = (sizeVal * 0.092903);
      return formatNumber(sqMeters) +str;
  } else {
      const sqFeet = (sizeVal);
      return formatNumber(sqFeet)  +str;
  }
};

export const CurrConvertPrice = (price) => {
  const { currencyType } = useGlobalStore()
  // const priceStr = ""
  let values = ["AED", "EUR", "GBP", "USD"]
  // get first currenct from env
  if (typeof process.env?.GATSBY_CURRENCYCONVERTER !== "undefined") {
    values = process.env.GATSBY_CURRENCYCONVERTER.split(",")
  }
  const currVal = values[0]

  // get localstorage value
  if (typeof window !== "undefined") {
    if (
      price &&
      currencyType?.value != null &&
      currencyType?.value !== currVal
    ) {
      // let calc
      return `${currencyType?.value} ${parseInt(
        calcPrice(price, currencyType?.value, currVal),
        10
      ).toLocaleString("en-US")}`
    }
  }

  return `${price ? `${currVal} ` : ""}${price}`
}


export const offCurrConvertPrice = (price) => {
  const { currencyType } = useGlobalStore()
  // const priceStr = ""
  let values = ["AED", "EUR", "GBP", "USD"]
  // get first currenct from env
  if (typeof process.env?.GATSBY_CURRENCYCONVERTER !== "undefined") {
    values = process.env.GATSBY_CURRENCYCONVERTER.split(",")
  }
  const currVal = values[0]

  // get localstorage value
  if (typeof window !== "undefined") {
    if (
      price &&
      currencyType?.value != null &&
      currencyType?.value !== currVal
    ) {
      // let calc
      return `${parseInt(
        calcPrice(price, currencyType?.value, currVal),
        10
      ).toLocaleString("en-US")}`
    }
  }

  return `${price ? price : ""}`
}

export const updateCurrencyList = (list) => {
  const updatePriceList = map(list, (data) => {
    const obj = { ...data }
    if (obj.value !== "") {
      obj.label = CurrConvertPrice(data.label.toLocaleString("en-US"))
    } else {
      obj.label = data?.label
    }
    return obj
  })
  return updatePriceList
}
